export const CustomerCleanerTypes = {
  GET_CUSTOMER_CLEANERS: 'GET_CUSTOMER_CLEANERS',
  CLEAR_CUSTOMER_CLEANERS: 'CLEAR_CUSTOMER_CLEANERS',
};
